import React, { useEffect, useState } from "react";
import axios from "axios";
import "./App.css";
//import Sidebar from "./Sidebar"; // Import Sidebar
//import Sidebar2 from "./Sidebar2"; // Import Sidebar
import { Sidebar, Sidebar2 } from "./Sidebar"; // ✅ Use named import
//import headerImage from "../images/NDS_Header_1.png";
// axios.get("/api/players")
//axios.get("http://localhost:8080/api/round1")   -- WORKING Locally
function App() {
    const [players, setPlayers] = useState([]);

    useEffect(() => {
        axios.get("/api/round1")
            .then(response => {
                const data = response.data;
    
                // If response is [players, metadata], extract players
                const playerData = Array.isArray(data) && Array.isArray(data[0]) ? data[0] : data;
    
                console.log("✅ Cleaned player data:", playerData);
                setPlayers(playerData);
            })
            .catch(error => console.error("❌ Error fetching round1 data:", error));
    }, []);

    return (
       
        <div className="container" style={{ backgroundColor: '#2c3e50', minHeight: '100vh' }}>
            
           
            {/* Header */}
            <header className="header">
                <h1>
                    <img src="/images/Test1.png" alt="Header" />
                </h1>
                {/* <img src="/header-image.png" alt="Header" /> */}
              {/*   <img src={headerImage} alt="Header" />;    */}
               {/*  <img src="/images/NDS_Header_1.png" alt="Header" />     */}   
              
            </header>

            <div className="content">
                {/* Left Section */}
                <aside className="left">
    {/* Rounds Panel */}
    <div className="panel">
        <h3>Rounds</h3>
        <ul className="list">
            {Array.from({ length: 7 }, (_, i) => (
                <li key={i}>Round {i + 1}</li>
            ))}
        </ul>
    </div>
    <div className="ad-placeholder">
        <p>Ad Placeholder</p>
    </div>
    {/* Positions Panel */}
    <div className="panel">
        <h3>Positions</h3>
        <ul className="list">
            {["QB", "RB", "WR", "TE", "OL", "DL", "LB", "CB", "S", "K", "P"].map((position, index) => (
                <li key={index}>{position}</li>
            ))}
        </ul>
    </div>
    <div className="ad-placeholder">
        <p>Ad Placeholder</p>
    </div>
</aside>

                {/* Center Section */}
                <main className="center">
                    {players.map((player, index) => (
                      <React.Fragment key={player.DraftPosition}>
                      {/* Player Box */}
                      <div className="player">
                          <p className="player-name">
                              {index + 1}. {player.FullName} ({player.PositionAbbr}) - {player.TeamName}
                          </p>
                           {/*  <p className="player-info">
                                {player.Age} | {player.Height} | {player.Weight} */}
                          <p className="player-details">
                                {player.CollegeName} - {player.SchoolYear}
                            </p>
                            <p className="scouting-report">
                                <strong>Scouting Report:</strong> {player.ScoutingReport}
                            </p>
      
                      </div>
          
                      {/* Advertisement Placeholder every 8 players */}
                      {((index + 1) % 8 === 0) && (
                          <div className="ad-placeholder">
                              <p>Ad Placeholder 1</p>
                          </div>
                      )}
                  </React.Fragment>
                    ))}
                    
                    {/* Final Advertisement Placeholder */}
                    <div className="ad-placeholder">
                        <p>Ad Placeholder 2</p>
                    </div>
                </main>

                {/* Right Section */}
                <aside className="right">
                   {/*  <div className="panel">Latest News</div> */}
                    <Sidebar />
                    <div className="ad-placeholder">
                        <p>Ad Placeholder</p>
                    </div>
                    <Sidebar />
                   {/*  <div className="panel">Teams</div> */}
                </aside>
            </div>

            {/* Footer */}
            <footer className="footer">
                <p>&copy; 2025 NDS</p>
                {/* <img src="/footer-image.png" alt="Footer" /> */}
               
                <img src="/images/Footer_1.png" alt="Footer" /> 
            </footer>
        </div>
    );
}

export default App;
